import React from "react";
import FinanceAccountListPage from "./FinanceAccountListPage";

const Payables = () => (
  <FinanceAccountListPage kind="payable" title="Contas a Pagar" endpoint="/finance/payables" />
);
export default Payables;
